/**
 * Tag families. A tag's `kind` is a string in the database so a new family
 * needs no migration; this list is what the UI knows how to name and where
 * Settings gets its sections. Add a family here and seed its tags.
 */
export interface TagKindMeta {
  id: string;
  /** Singular, for buttons ("Add feature") and headings. */
  label: string;
  /** Plural, for the Settings section title and the request field. */
  plural: string;
}

export const TAG_KINDS: TagKindMeta[] = [{ id: "feature", label: "Feature", plural: "Features" }];

/** Meta for a kind, falling back to a capitalised id for a kind seeded
 *  straight into the database that this list does not know yet. */
export function tagKind(id: string): TagKindMeta {
  return TAG_KINDS.find((k) => k.id === id) ?? { id, label: id.charAt(0).toUpperCase() + id.slice(1), plural: `${id.charAt(0).toUpperCase() + id.slice(1)}s` };
}

/** Slug id for a tag name: "Funds / MDF" → "funds-mdf". Empty when the name
 *  has no letters or digits. */
export function tagSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
